import { render, staticRenderFns } from "./groupCustomer_detail.vue?vue&type=template&id=517c57a0&scoped=true"
import script from "./groupCustomer_detail.vue?vue&type=script&lang=js"
export * from "./groupCustomer_detail.vue?vue&type=script&lang=js"
import style0 from "./groupCustomer_detail.vue?vue&type=style&index=0&id=517c57a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517c57a0",
  null
  
)

export default component.exports